<script>
    import { Pie } from 'vue-chartjs'

    export default {
        extends: Pie,
        props: ["chartdata"],
        mounted() {
            this.renderChart(this.chartdata, {
                borderWidth: "10px",
                hoverBackgroundColor: "red",
                hoverBorderWidth: "10px"
            },
                { responsive: true, maintainAspectRatio: false })

                Chart.defaults.global.legend.display = false;

            // Chart.defaults.global.legend = {
            //     display: true,
            // }
        }
    }
</script>

<style scoped>



</style>
